import template from 'lodash/template';
import { ajaxSend } from '../../../api/api';
const getPath = template('/v1/teams/${teamId}/agents');
export const getTeamAgents = (teamId, params = {}) => ajaxSend({
    path: getPath({ teamId }),
    params: params,
});
export const addAgentsToTeam = (teamId, agentIds) => ajaxSend({
    path: getPath({ teamId }),
    method: 'PUT',
    data: { agent_ids: agentIds },
});
export const removeAgentsFromTeam = (teamId, agentIds) => ajaxSend({
    method: 'DELETE',
    path: `${getPath({ teamId })}`,
    data: { agent_ids: agentIds },
});
